/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-tracker
 * Portfolio-tracker
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProrationAmountDto
 */
export interface ProrationAmountDto {
    /**
     * 
     * @type {number}
     * @memberof ProrationAmountDto
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof ProrationAmountDto
     */
    currency: string;
}

export function ProrationAmountDtoFromJSON(json: any): ProrationAmountDto {
    return ProrationAmountDtoFromJSONTyped(json, false);
}

export function ProrationAmountDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProrationAmountDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'amount': json['amount'],
        'currency': json['currency'],
    };
}

export function ProrationAmountDtoToJSON(value?: ProrationAmountDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'amount': value.amount,
        'currency': value.currency,
    };
}

